import React from 'react'
import { Link } from 'react-router-dom'
import { ADMIN_CONTACT } from '../../services/authConfig'

const PageNotFound = () => {
  return (
    <div>
      <div className='df ml100 fxdrc aifs'>
        <h1>Page Not Found</h1>
        <p>You've come to a page of the site that doesn't exist. If you entered a web address please check if it was correct or maybe you followed a link to a page that was removed.</p>
        <p>Click <Link className='c-blue-500' to="/dashboard">here</Link> to go back to the dashboard.</p>
        <p>If you believe there is a mistake, please contact support at <a target='_blank' className='c-blue-500' href={'mailto:' + ADMIN_CONTACT}>{ADMIN_CONTACT}</a></p>
      </div>
    </div>
  )
}

export default PageNotFound